import styled from 'styled-components';
import { tablet768, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

const TextBlock = styled(Block)`
  ${paddingBuilder.all(3.5, 1.5, 3.5, 0)}

  ${tablet768`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex: 1 1 50%;

    ${paddingBuilder.all(8.5, 3.5, 8.5, 0)}
  `}

  ${desktop1440`
    ${paddingBuilder.all(15.5, 3.5, 15.5, 0)}
  `}
`;

const InnerContainer = styled.div`
  width: 100%;
  height: auto;
  max-width: 720px;

  ${paddingBuilder.left(1.5)}

  ${tablet768`
    ${paddingBuilder.left(3.5)}
  `}
`;

InnerContainer.displayName = 'TextBlock.InnerContainer';

TextBlock.displayName = 'TextBlock';
TextBlock.InnerContainer = InnerContainer;

export default TextBlock;
